import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import * as Sentry from '@sentry/react';

import Router from './Router';
import { QueryProvider } from './lib/query/QueryProvider';
import SentryFallback from './lib/sentry/fallback';
import './lib/sentry/init';
import './styles/index.scss';

const container = document.getElementById('root');
const root = createRoot(container!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <StrictMode>
    <QueryProvider>
      <Sentry.ErrorBoundary fallback={<SentryFallback />}>
        <Router />
      </Sentry.ErrorBoundary>
    </QueryProvider>
  </StrictMode>,
);
